import { useState, useRef, useEffect } from "react";
import { Text } from "@mantine/core";

interface ReadMoreTextProps {
  text: string;
  lines?: number;
  size?: string;
}

export default function ReadMoreText({ text, lines = 3, size = "sm" }: ReadMoreTextProps) {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const spanRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = spanRef.current;
    if (!el) return;

    const check = () => setIsClamped(el.scrollHeight > el.clientHeight);
    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [text, lines]);

  if (!text) return <Text size={size as any}>N/A</Text>;

  return (
    <Text size={size as any}>
      <span
        ref={spanRef}
        style={
          !expanded
            ? {
                display: "-webkit-box",
                WebkitLineClamp: lines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
            : undefined
        }
      >
        {text}
      </span>
      {(isClamped || expanded) && (
        <span
          onClick={() => setExpanded((prev) => !prev)}
          style={{ color: "#2563EB", cursor: "pointer", whiteSpace: "nowrap", marginLeft: 2 }}
        >
          {expanded ? "Show Less" : "Know More"}
        </span>
      )}
    </Text>
  );
}
